import { useLayoutEffect, useState } from 'react'

const offsetWithin = (element: HTMLElement, scrollElement: HTMLElement) => {
  let offset = 0
  let node: Element | null = element

  while (node instanceof HTMLElement && node !== scrollElement) {
    offset += node.offsetTop
    node = node.offsetParent
  }

  return offset
}

export const useScrollMargin = (
  element: HTMLElement | null,
  scrollElement: HTMLElement | null
) => {
  const [scrollMargin, setScrollMargin] = useState(0)

  useLayoutEffect(() => {
    const content = scrollElement?.firstElementChild

    if (!element || !scrollElement || !content) return

    const resizeObserver = new ResizeObserver(() =>
      setScrollMargin(offsetWithin(element, scrollElement))
    )
    const observeSections = () => {
      resizeObserver.observe(content)
      Array.from(content.children).forEach((section) =>
        resizeObserver.observe(section)
      )
    }
    const mutationObserver = new MutationObserver(observeSections)

    observeSections()
    mutationObserver.observe(content, { childList: true })

    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
    }
  }, [element, scrollElement])

  return scrollMargin
}
